import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { usePropertySettings } from './PropertySettingsContext';
import CalendarSharing from '../components/CalendarSharing';

const SharingSettingsPage = () => {
    const { property } = usePropertySettings();

    return (
        <Stack spacing={2.5}>
            <Alert
                severity="info"
                sx={{
                    borderRadius: 0,
                    border: '3px solid #6366f1',
                    backgroundColor: 'rgba(99, 102, 241, 0.1)',
                    fontWeight: 600,
                    '& .MuiAlert-icon': {
                        color: '#6366f1',
                    },
                }}
            >
                Changes take effect immediately
            </Alert>
            <CalendarSharing
                propertyId={property.id}
                disabled={false}
            />
        </Stack>
    );
};

export default SharingSettingsPage;
